import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const DEALS_PATH = "/bon-plans";
const DEAL_DETAIL_PATH = "/bon-plans/famille/:familyId";
const DEAL_PARTNER_OFFER_DETAIL_PATH = "/bon-plans/offre-partenaire/:offerId";
const DEALS_CONFIRMATION_PATH = "/bon-plans/confirmation";
const DEAL_ORDER_DETAIL_PATH = "/bon-plans/commandes/:id";

const DealsPage = lazyWithRetry(() => import("@/features/deals/pages/DealsPage"));
const DealDetailPage = lazyWithRetry(() => import("@/features/deals/pages/DealDetailPage"));
const DealPartnerOfferDetailPage = lazyWithRetry(() => import("@/features/deals/pages/DealPartnerOfferDetailPage"));
const DealsOrderConfirmationPage = lazyWithRetry(() => import("@/features/deals/pages/DealsOrderConfirmationPage"));
const DealOrderDetailPage = lazyWithRetry(() => import("@/features/deals/pages/DealOrderDetailPage"));

const dealsRoutes: RouteConfig[] = [
  {
    path: DEALS_PATH,
    element: <DealsPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: DEAL_DETAIL_PATH,
    element: <DealDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: DEAL_PARTNER_OFFER_DETAIL_PATH,
    element: <DealPartnerOfferDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: DEALS_CONFIRMATION_PATH,
    element: <DealsOrderConfirmationPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: DEAL_ORDER_DETAIL_PATH,
    element: <DealOrderDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default dealsRoutes;
export {
  DEALS_PATH,
  DEAL_DETAIL_PATH,
  DEAL_PARTNER_OFFER_DETAIL_PATH,
  DEALS_CONFIRMATION_PATH,
  DEAL_ORDER_DETAIL_PATH,
};
